import Vue from 'vue'
import axios from 'axios';
import Router from 'vue-router'
import login from '@/components/login/login'
import clearToken from '@/components/login/clearToken'
import getToken from '@/components/login/getToken'
import redirectLogin from '@/components/login/redirectLogin'
import noPermission from '@/components/login/noPermission'
import mobileLogin from '@/components/login/mobileLogin'
import ymtLogin from '@/components/login/ymtLogin'
import mobileSurvey from '@/components/login/mobileSurvey'
import mobilePreview from '@/components/login/mobilePreview'
import favConList from '@/components/login/favConList'
import agreeBook from '@/components/login/agreeBook'
import forceToFollow from '@/components/login/forceToFollow'
import userAgreement from '@/components/login/userAgreement'
import mobileContent from '@/components/login/mobileContent'
import allRemove from '@/components/login/allRemove'
import index from '@/components/index/index'
import userManager from '@/components/pages/userManager/userManager'
import userList from '@/components/pages/userManager/userList'
import nonHCPList from '@/components/pages/userManager/nonHCPList'
import userDetail from '@/components/pages/userManager/userDetail'
import mainDateManager from '@/components/pages/mainDateManager/mainDateManager'
import mainDateList from '@/components/pages/mainDateManager/mainDateList'
import mainDateContain from '@/components/pages/mainDateManager/mainDateContain'
import editMainDateList from '@/components/pages/mainDateManager/editMainDateList'
import editMainDatePic from '@/components/pages/mainDateManager/editMainDatePic'
import editMainDateText from '@/components/pages/mainDateManager/editMainDateText'
import editMainDateAll from '@/components/pages/mainDateManager/editMainDateAll'
import categoryList from '@/components/pages/mainDateManager/categoryList'
import categoryNewList from '@/components/pages/contentManger/categoryNewList'
import contenOperateLog from '@/components/pages/contentManger/contenOperateLog'

import buBrandList from '@/components/pages/contentManger/buBrandList'
import lifecyclePage from '@/components/pages/contentManger/lifecyclePage'
import editCategoryList from '@/components/pages/mainDateManager/editCategoryList'
import contentManger from '@/components/pages/contentManger/contentManger'
import contenList from '@/components/pages/contentManger/contenList'
import contenListAll from '@/components/pages/contentManger/contenListAll'
import productList from '@/components/pages/contentManger/productList'
import editContList from '@/components/pages/contentManger/editContList'
import commentList from '@/components/pages/contentManger/commentList'
import ContentRelease from '@/components/pages/contentManger/ContentRelease'
import ContentReleaseList from '@/components/pages/contentManger/ContentReleaseList'
import ContentMemberList from '@/components/pages/contentManger/ContentMemberList'
import permissionManger from '@/components/pages/permissionManger/permissionManger'
import authorityList from '@/components/pages/permissionManger/authorityList'
import myPersonalRoleList from '@/components/pages/permissionManger/myPersonalRoleList'
import meetingDetail from '@/components/login/meetingDetail'
import meetingList from '@/components/login/meetingList'
import myMeetingList from '@/components/login/myMeetingList'
import myMeetingDetail from '@/components/login/myMeetingDetail'
import videoManager from '@/components/pages/videoManager/videoManager'
import carouselList from '@/components/pages/videoManager/carouselList'
import videoList from '@/components/pages/videoManager/videoList'
import knowledgVideoList from '@/components/login/knowledgVideoList'
import qrCodeManager from '@/components/pages/qrCodeManager/qrCodeManager'
import channelQrCode from '@/components/pages/qrCodeManager/channelQrCode'
import channelFollowList from '@/components/pages/qrCodeManager/channelFollowList'
import autoReplyManager from '@/components/pages/autoReplyManager/autoReplyManager'
import keyWordList from '@/components/pages/autoReplyManager/keyWordList'
import articleReports from '@/components/pages/mainDateManager/articleReports'
import tagManager from '@/components/pages/tagManager/tagManager'
import tagList from '@/components/pages/tagManager/tagList'
import aiTagList from '@/components/pages/tagManager/aiTagList'

import topicManager from '@/components/pages/topicManager/topicManager'
import topicList from '@/components/pages/topicManager/topicList'

import indicationsManager from '@/components/pages/IndicationsManager/IndicationsManager'
import indicationsList from '@/components/pages/IndicationsManager/IndicationsList'

import operationLogs from '@/components/pages/userManager/operationLogs'
import operationLogs_nonHCP from '@/components/pages/userManager/operationLogs_nonHCP'
import followDetailList from '@/components/pages/qrCodeManager/followDetailList'
import registerDetailList from '@/components/pages/qrCodeManager/registerDetailList'
import articalCollections from '@/components/login/articalCollections'
import countyCollections from '@/components/login/countyCollections'
import aggregateMobile from '@/components/login/aggregateMobile'
import articalSearchList from '@/components/login/articalSearchList'
import countySearchList from '@/components/login/countySearchList'
import mobileOnLive from '@/components/pages/mobileOnLive/mobileOnLive'
import mobileOnLiveSearch from '@/components/pages/mobileOnLive/mobileOnLiveSearch'
import messageManager from '@/components/pages/messageManager/messageManager'
import surveryManager from '@/components/pages/surveryManager/surveryManager'
import surveryList from '@/components/pages/surveryManager/surveryList'
import surveryData from '@/components/pages/surveryManager/surveryData'
import messagePushing from '@/components/pages/messageManager/messagePushing'
import messageLog from '@/components/pages/messageManager/messageLog'
import meetingPushing from '@/components/pages/messageManager/meetingPushing'
import aggregateManager from '@/components/pages/aggregateManager/aggregateManager'
import aggregateList from '@/components/pages/aggregateManager/aggregateList'

// myPKFit
import myPkIndex from '@/components/myPkFit/myPkIndex'
import myPkHome from '@/components/myPkFit/myPkHome'
import myInstructionBook from '@/components/myPkFit/myInstructionBook'
import myQA from '@/components/myPkFit/Q&A'
import myOperationVideo from '@/components/myPkFit/operationVideo'
import myRegistration from '@/components/myPkFit/myRegistration'
import myMinigame from '@/components/myPkFit/myMinigame'


// 直播
import onManagement from '@/components/pages/onManagement/onManagement'
import onLiveList from '@/components/pages/onManagement/onLiveList'

//  文章集锦管理--武田推文管理
import articleManage from '@/components/pages/articleManage/articleManage'
import takedaArticleManage from '@/components/pages/articleManage/takedaArticleManage'
import takedaCountyManage from '@/components/pages/articleManage/takedaCountyManage'

// 移动端错误页面

import errPage from '@/components/pages/errPage/errPage'

import feedFlarePage from '@/components/pages/feedFlarePage/feedFlarePage'
import feedFlareManage from '@/components/pages/feedFlareManage/feedFlareManage'
import feedFlareList from '@/components/pages/feedFlareManage/feedFlareList'

// 我的客户
import myCustomCollections from '@/components/login/myCustomCollections'
import articlePushManage from '@/components/login/articlePushManage'


//埋点记录
import burialPointRecordManger from '@/components/pages/burialPointRecord/burialPointRecord'
import burialPointArticleLog from '@/components/pages/burialPointRecord/burialPointArticleLog'
import burialPointSearchHistory from '@/components/pages/burialPointRecord/burialPointSearchHistory'
import burialPointActionHistory from '@/components/pages/burialPointRecord/burialPointActionHistory'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/allRemove',
      name: 'allRemove',
      component: allRemove
    },
    {
      path: '/clearToken',
      name: 'clearToken',
      component: clearToken
    },
    {
      path: '/getToken',
      name: 'getToken',
      component: getToken
    },
    {
      path: '/favConList',
      name: 'favConList',
      component: favConList
    },
    {
      path: '/noPermission',
      name: 'noPermission',
      component: noPermission
    },
    {
      path: '/mobileSurvey',
      name: 'mobileSurvey',
      component: mobileSurvey
    },
    {
      path: '/mobilePreview',
      name: 'mobilePreview',
      component: mobilePreview
    },
    {
      path: '/register',
      name: 'register',
      component: mobileLogin,
      meta: {
        title: '个人中心',
        keepAlive: true
      }
    },
    {
      path: '/ymtLogin',
      name: 'ymtLogin',
      component: ymtLogin,
      meta: {
        title: '授权注册中',
        keepAlive: true
      }
    },
    {
      path: '/agreeBook',
      name: 'agreeBook',
      component: agreeBook
    },
    {
      path: '/forceToFollow',
      name: 'forceToFollow',
      component: forceToFollow
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: userAgreement
    },
    {
      path: '/redirectLogin',
      name: 'redirectLogin',
      component: redirectLogin
    },
    {
      path: '/mobileContent',
      name: 'mobileContent',
      component: mobileContent
    },
    {
      path: '/meetingDetail/:id',
      name: 'meetingDetail',
      component: meetingDetail
    },
    {
      path: '/meetingList',
      name: 'meetingList',
      component: meetingList,
      meta: {
        title: '会议日历'
      }
    },
    {
      path: '/myMeetingList',
      name: 'myMeetingList',
      component: myMeetingList,
      meta: {
        title: '会议日历'
      }
    },
    {
      path: '/myMeetingDetail',
      name: 'myMeetingDetail',
      component: myMeetingDetail,
      meta: {
        title: '会议日历'
      }
    },
    {
      path: '/knowledgVideoList',
      name: 'knowledgVideoList',
      component: knowledgVideoList,
      meta: {
        title: '产品知识库'
      }
    },
    {
      path: '/articalCollections',
      name: 'articalCollections',
      component: articalCollections,
      meta: {
        title: '文章集锦',
        keepAlive: true
      }
    },
    {
      path: '/countyCollections',
      name: 'countyCollections',
      component: countyCollections,
      meta: {
        title: '血液制品专区',
        keepAlive: true
      }
    },
    {
      path: '/myCustomCollections',
      name: 'myCustomCollections',
      component: myCustomCollections,
      meta: {
        title: '我的客户',
        keepAlive: true
      }
    },
    {
      path: '/aggregateMobile',
      name: 'aggregateMobile',
      component: aggregateMobile,
      meta: {
        title: '品牌专区',
        keepAlive: true
      }
    },
    {
      path: '/articlePushManage',
      name: 'articlePushManage',
      component: articlePushManage,
      meta: {
        title: '推选文章',
        keepAlive: true
      }
    },
    {
      path: '/articalSearchList',
      name: 'articalSearchList',
      component: articalSearchList,
      meta: {
        title: '搜索',
        keepAlive: true
      }
    },
    {
      path: '/countySearchList',
      name: 'countySearchList',
      component: countySearchList,
      meta: {
        title: '搜索',
        keepAlive: true
      }
    },
    {
      path: '/mobileOnLive',
      name: 'mobileOnLive',
      component: mobileOnLive,
      meta: {
        title: '武田直播',
        keepAlive: true
      }
    },
    {
      path: '/mobileOnLiveSearch',
      name: 'mobileOnLiveSearch',
      component: mobileOnLiveSearch,
      meta: {
        title: '武田直播',
        keepAlive: true
      }
    },
    // 移动端错误页面
    {
      path: '/errPage',
      name: 'errPage',
      component: errPage,
      meta: {
        title: '吾医空间',
        keepAlive: true
      }
    },

    {
      path: '/feedFlarePage',
      name: 'feedFlarePage',
      component: feedFlarePage,
      meta: {
        title: '吾医空间',
        keepAlive: true
      }
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      redirect: '/newIndex',
      children: [
        {
          path: '/userManager',
          name: 'userManager',
          component: userManager,
          redirect: '/userList',
          children: [
            {
              path: '/userList',
              name: 'userList',
              component: userList
            }
          ]
        },
        {
          path: '/mainDateManager',
          name: 'mainDateManager',
          component: mainDateManager,
          redirect: '/mainDateList',
          children: [
            {
              path: '/mainDateList',
              name: 'mainDateList',
              component: mainDateList
            },
            {
              path: '/mainDateContain',
              name: 'mainDateContain',
              component: mainDateContain
            },
            {
              path: '/editMainDateList',
              name: 'editMainDateList',
              component: editMainDateList
            },
            {
              path: '/editMainDatePic/:id',
              name: 'editMainDatePic',
              component: editMainDatePic
            },
            {
              path: '/editMainDateText/:id',
              name: 'editMainDateText',
              component: editMainDateText
            },
            {
              path: '/editMainDateAll/:id',
              name: 'editMainDateAll',
              component: editMainDateAll
            },
            {
              path: '/ContentRelease',
              name: 'ContentRelease',
              component: ContentRelease
            },
            {
              path: '/ContentReleaseList',
              name: 'ContentReleaseList',
              component: ContentReleaseList
            },
            {
              path: '/categoryList',
              name: 'categoryList',
              component: categoryList
            },
            {
              path: '/editCategoryList/:id',
              name: 'editCategoryList',
              component: editCategoryList
            },
            {
              path: '/articleReports',
              name: 'articleReports',
              component: articleReports
            }
          ]
        },
        {
          path: '/contentManger',
          name: 'contentManger',
          component: contentManger,
          redirect: '/contenList',
          children: [
            {
              path: '/contenList',
              name: 'contenList',
              component: contenList
            },
            {
              path: '/contentReadAll',
              name: 'contentReadAll',
              component: contenListAll
            },
            {
              path: '/categoryNewList',
              name: 'categoryNewList',
              component: categoryNewList
            },
            {
              path: '/contenOperateLog',
              name: 'contenOperateLog',
              component: contenOperateLog
            },
            {
              path: '/buBrandList',
              name: 'buBrandList',
              component: buBrandList
            },
            {
              path: '/lifecyclePage',
              name: 'lifecyclePage',
              component: lifecyclePage
            },
            {
              path: '/editContList',
              name: 'editContList',
              component: editContList
            },
            {
              path: '/productList',
              name: 'productList',
              component: productList
            },
            {
              path: '/commentList',
              name: 'commentList',
              component: commentList
            },
            {
              path: '/ContentMemberList',
              name: 'ContentMemberList',
              component: ContentMemberList
            }
          ]
        },
        {
          path: '/permissionManger',
          name: 'permissionManger',
          component: permissionManger,
          redirect: '/authorityList',
          children: [
            {
              path: '/authorityList',
              name: 'authorityList',
              component: authorityList
            },
            {
              path: '/myPersonalRoleList',
              name: 'myPersonalRoleList',
              component: myPersonalRoleList
            }
          ]
        },
        {
          path: '/userManager',
          name: 'userManager',
          component: userManager,
          redirect: '/userList',
          children: [
            {
              path: '/userList',
              name: 'userList',
              component: userList
            },
            {
              path: '/userDetail',
              name: 'userDetail',
              component: userDetail
            },
            {
              path: '/operationLogs',
              name: 'operationLogs',
              component: operationLogs
            },
            {		 
              path: '/nonHCPList',		 
              name: 'nonHCPList',		 
              component: nonHCPList		 
            },		 
            {		 
              path: '/operationLogs_nonHCP',		 
              name: 'operationLogs_nonHCP',		 
              component: operationLogs_nonHCP		 
            }
          ]
        },
        {
          path: '/videoManager',
          name: 'videoManager',
          component: videoManager,
          redirect: '/carouselList',
          children: [
            {
              path: '/carouselList',
              name: 'carouselList',
              component: carouselList
            },
            {
              path: '/videoList',
              name: 'videoList',
              component: videoList
            }
          ]
        },

        // 跳转配置
        {
          path: '/feedFlareManage',
          name: 'feedFlareManage',
          component: feedFlareManage,
          redirect: '/feedFlareList',
          children: [
            {
              path: '/feedFlareList',
              name: 'feedFlareList',
              component: feedFlareList
            }
          ]
        },
              // 直播
      // import onManagement from '@/components/pages/onManagement/onManagement'
    // import onLiveList from '@/components/pages/onManagement/onLiveList'
        {
          path: '/onManagement',
          name: 'onManagement',
          component: onManagement,
          redirect: '/onLiveList',
          children: [
            {
              path: '/onLiveList',
              name: 'onLiveList',
              component: onLiveList
            }
          ]
        },
        // 文章集锦管理
        {
          path: '/articleManage',
          name: 'articleManage',
          component: articleManage,
          redirect: '/takedaArticleManage',
          children: [
            {
              path: '/takedaArticleManage',
              name: 'takedaArticleManage',
              component: takedaArticleManage
            },
            {
              path: '/takedaCountyManage',
              name: 'takedaCountyManage',
              component: takedaCountyManage
            }
          ]
        },
        {
          path: '/messageManager',
          name: 'messageManager',
          component: messageManager,
          redirect: '/messagePushing',
          children: [
            {
              path: '/messagePushing',
              name: 'messagePushing',
              component: messagePushing
            },
            {
              path: '/messageLog',
              name: 'messageLog',
              component: messageLog
            },
            {
              path: '/meetingPushing',
              name: 'meetingPushing',
              component: meetingPushing
            }
          ]
        },
        {
          path: '/surveryManager',
          name: 'surveryManager',
          component: surveryManager,
          redirect: '/surveryList',
          children: [
            {
              path: '/surveryList',
              name: 'surveryList',
              component: surveryList
            },
            {
              path: '/surveryData',
              name: 'surveryData',
              component: surveryData
            }
          ]
        },
        {
          path: '/qrCodeManager',
          name: 'qrCodeManager',
          component: qrCodeManager,
          redirect: '/channelQrCode',
          children: [
            {
              path: '/channelQrCode',
              name: 'channelQrCode',
              component: channelQrCode
            },
            {
              path: '/channelFollowList',
              name: 'channelFollowList',
              component: channelFollowList,
              meta: {
                keepAlive: true
              }
            },
            {
              path: '/followDetailList',
              name: 'followDetailList',
              component: followDetailList
            },
            {
              path: '/registerDetailList',
              name: 'registerDetailList',
              component: registerDetailList
            }
          ]
        },
        {
          path: '/autoReplyManager',
          name: 'autoReplyManager',
          component: autoReplyManager,
          redirect: '/keyWordList',
          children: [
            {
              path: '/keyWordList',
              name: 'keyWordList',
              component: keyWordList
            }
          ]
        },
        {
          path: '/tagManager',
          name: 'tagManager',
          component: tagManager,
          redirect: '/tagList',
          children: [
            {
              path: '/tagList',
              name: 'tagList',
              component: tagList
            },
            {
              path: '/aiTagList',
              name: 'aiTagList',
              component: aiTagList
            }
          ]
        },

        {
          path: '/topicManager',
          name: 'topicManager',
          component: topicManager,
          redirect: '/topicList',
          children: [
            {
              path: '/topicList',
              name: 'topicManager',
              component: topicList
            }
          ]
        },
        {
          path: '/indicationsManager',
          name: 'indicationsManager',
          component: indicationsManager,
          redirect: '/indicationsList',
          children: [
            {
              path: '/indicationsList',
              name: 'indicationsManager',
              component: indicationsList
            }
          ]
        },

        {
          path: '/aggregateManager',
          name: 'aggregateManager',
          component: aggregateManager,
          redirect: '/aggregateList',
          children: [
            {
              path: '/aggregateList',
              name: 'aggregateList',
              component: aggregateList
            }
          ]
        },
        {
          path: '/burialPointRecordManger',
          name: 'burialPointRecordManger',
          component: burialPointRecordManger,
          redirect: '/burialPointArticleLog',
          children: [
            {
              path: '/burialPointArticleLog',
              name: 'burialPointArticleLog',
              component: burialPointArticleLog
            },
            {
              path: '/burialPointSearchHistory',
              name: 'burialPointSearchHistory',
              component: burialPointSearchHistory
            },
            {
              path: '/burialPointActionHistory',
              name: 'burialPointActionHistory',
              component: burialPointActionHistory
            },
          ]
        },
      ]
    },
    {
      path: '/myPkIndex',
      name: 'myPkIndex',
      component: myPkIndex,
      redirect: '/myPkHome',
      children: [
        {
          path: '/myPkHome',
          name: 'myPkHome',
          component: myPkHome,
          meta: {
            title: '主页'
          }
        },
        {
          path: '/myRegistration',
          name: 'myRegistration',
          component: myRegistration,
          meta: {
            title: '账户申请'
          }
        },
        {
          path: '/myInstructionBook',
          name: 'myInstructionBook',
          component: myInstructionBook,
          meta: {
            title: '说明书'
          }
        },
        {
          path: '/myQA',
          name: 'myQA',
          component: myQA,
          meta: {
            title: '问题回复'
          }
        },
        {
          path: '/myOperationVideo',
          name: 'myOperationVideo',
          component: myOperationVideo,
          meta: {
            title: '操作视频'
          }
        },
        {
          path: '/myMinigame',
          name: 'myMinigame',
          component: myMinigame,
          meta: {
            title: '小游戏'
          }
        },

      ]
    }
  ],
  mode: 'history'
})
router.beforeEach((to, from, next) => {
  console.log('我来自----',from,'我要去------',to)
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if(!from.name&&to.name==='mobileContent'){
    //直接进入文章链接
     // 获取当前的完整 URL
      const baseUrl = window.location.origin; // 获取协议 + 主机名
      const fullPath = to.fullPath; // 获取路径和查询参数
      const completeUrl = `${baseUrl}${fullPath}`; // 拼接完整 URL
      localStorage.setItem('firstVisitUrl', completeUrl);
  }
  if((from.name==='favConList'&&to.name==='articalCollections' )||(from.name==='mobileContent'&&to.name==='articalCollections')||(from.name==='mobileContent'&&to.name==='articalSearchList')){
    const { protocol, host } = window.location;
    let myurl = ''
    if(to.name==='articalSearchList'){
      //搜索不需要记录地址
      myurl =`${protocol}${protocol.endsWith('//') ? '' : '//'}${host}/articalSearchList` 
      // protocol+host+'/articalSearchList'
    }else{
      myurl = `${protocol}${protocol.endsWith('//') ? '' : '//'}${host}${to.fullPath}`;
    }
    //我的收藏/文章详情返回埋点
    let data = {
      openid: window.localStorage.getItem('openId')||'',
      actionType:1,
      url:myurl
    }
    axios.post('/api/Logs/logstart', data).then( p => {
      console.log('我的收藏/文章详情返回埋点')
    } )
  }
  if(from.name==='articalCollections'||from.name==='favConList'){
    // 离开首页/收藏
    clearInterval(this.$intervalTime)
    window.sessionStorage.setItem('isOne','')
    const transactionId = window.sessionStorage.getItem('transactionId')
    axios.get(`/api/Logs/logend/${transactionId}`).then( p => {
      
      window.sessionStorage.setItem('transactionId','')
      console.log('离开首页/收藏行为埋点')
    } )
  }
  if(to.name==='articalCollections'){
    //进入首页
    if(!window.sessionStorage.getItem('isOne') && window.localStorage.getItem('TaToken')){
      window.sessionStorage.setItem('isOne',true)
      const { protocol, host } = window.location;
      // 检查 protocol 是否已经包含 //
      const myurl = `${protocol}${protocol.endsWith('//') ? '' : '//'}${host}${to.fullPath}`;
      const thens = this
      let data = {
        openid: window.localStorage.getItem('openId')||'',
        actionType:4,
        url:myurl
      }
      setTimeout(()=>{
        axios.post('/api/Logs/logstart', data).then( p => {
          console.log('路由进入首页行为埋点')
          if(p.data){
            window.sessionStorage.setItem('transactionId',p.data.data)
                  //遍历时间
                  thens.$intervalTime = setInterval(()=>{
                  const transactionId = window.sessionStorage.getItem('transactionId')
                    axios.get(`/api/Logs/logend/${transactionId}`).then( p => {
                    console.log('首页刷新埋点')
                  } )
                },2000)
          }
        } )
      },1500)
      
    } 
  }else if(to.name==='favConList'){
    //进入收藏
    if(!window.sessionStorage.getItem('isOne') && window.localStorage.getItem('TaToken')){
      window.sessionStorage.setItem('isOne',true)
      const { protocol, host } = window.location;
      const myurl = `${protocol}${protocol.endsWith('//') ? '' : '//'}${host}${to.fullPath}`;
      let data = {
        openid: window.localStorage.getItem('openId')||'',
        actionType:5,
        url:myurl
      }
      setTimeout(()=>{
        axios.post('/api/Logs/logstart', data).then( p => {
          console.log('路由进入收藏行为埋点')
          if(p.data){
            window.sessionStorage.setItem('transactionId',p.data.data)
          }
        } )
      },1500)
    } 
  }

  
  next()
  // let url = window.location.href
  // let permissionList = JSON.parse(window.sessionStorage.getItem('promissions'))
  // if (url.indexOf('ContentReleaseList') >= 0 && url.indexOf('appId') >= 0) {
  //   let appIdList = window.location.href.split('?')[window.location.href.split('?').length - 1].split('&')
  //   let beforeappId = ''
  //   for (let i = 0; i < appIdList.length; i++) {
  //     if (appIdList[i].split('=')[0] === 'appId') {
  //       beforeappId = appIdList[i].split('=')[1]
  //     }
  //   }
  //   if (permissionList === null || permissionList === undefined) {
  //     window.sessionStorage.setItem('beforeSrc', window.location.href)
  //     window.sessionStorage.setItem('beforeappId', beforeappId)
  //     window.location.href = (window.location.href.split('/#/')[0] + '/#/login')
  //     window.location.reload()
  //     return
  //   }
  //   let flag = true
  //   for (let i = 0; i < permissionList.length; i++) {
  //     if (parseInt(permissionList[i].appId) === parseInt(beforeappId)) {
  //       // this.choooseMyApp(this.permissionList[i])
  //       flag = false
  //       window.sessionStorage.setItem('nowApp', JSON.stringify(permissionList[i]))
  //       window.sessionStorage.setItem('AppId', beforeappId)
  //       window.location.href = (window.location.href.replace('appId=', ''))
  //       // next()
  //       window.location.reload()
  //       console.log(1111111111111111111)
  //       return
  //     }
  //   }
  //   if (flag) {
  //     alert('您无法看到这个APP的文章！')
  //     window.location.href = (window.location.href.split('/#/')[0] + '/#/login')
  //     window.location.reload()
  //     return
  //   }
  // }
  // if (to.name === 'login') {
  //   next()
  //   window.sessionStorage.setItem('needNotice', 'false')
  //   return
  // }
  // if (!window.sessionStorage.getItem('token') && to.name !== 'login') {
  //   window.location.href = (window.location.href.split('/#/')[0] + '/#/login')
  //   window.location.reload()
  //   return
  // }
  // if (to.name !== from.name) {
  //   if (window.sessionStorage.getItem('needNotice') === 'true') {
  //     common.doubleComfirm({
  //       content: '确定要跳转吗？如果您有未保存的内容，可能会丢失哦。',
  //       successFun: msg => {
  //         next()
  //         window.sessionStorage.setItem('needNotice', 'false')
  //       },
  //       errorFun: msg => {
  //       }
  //     })
  //   } else {
  //     next()
  //   }
  // } else {
  //   next()
  //   window.sessionStorage.setItem('needNotice', 'false')
  // }
  // let warningArray = ['editApplication', 'sysConfigEdit', 'editMainDateList', 'editCategoryList']
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js